import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-qwiklabs',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24"><title>Qwiklabs icon</title><path d="M14.346 18.205A6.464 6.464 0 0 0 12 5.72a6.462 6.462 0 0 0-2.346 12.485.69.69 0 0 0 .961-.623v-5.4a1.385 1.385 0 1 1 2.77 0v5.4a.692.692 0 0 0 .961.623zm.809 5.558C20.252 22.378 24 17.718 24 12.182c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.536 3.748 10.196 8.845 11.581a.7.7 0 0 0 .049.013l.059.016.001-.002a1.385 1.385 0 0 0 .635-2.695 9.231 9.231 0 1 1 4.824-.001 1.385 1.385 0 0 0 .635 2.695l.001.002.059-.016.049-.013z"/></svg>`,
    styles: []
})
export class SimpleIconsQwiklabsComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F5CD0E';
    @Input() className: string = 'simple-icons-qwiklabs'
    constructor() {}
    ngOnInit(): void {}
}
